import React from "react";
import "./CreateProject.css";
import ProjectForm from "../ProjectForm/ProjectForm";
import DocBlock from "../DocBlock/DocBlock";

const CreateProject = (props) => {
  return (
    <section className="project-area my-5">
      <div className="container">
        <ProjectForm></ProjectForm>
        <DocBlock></DocBlock>
      </div>
    </section>
  );
};

export default CreateProject;
